/**
 * Component - Add to Cart Price Display
 * Dynamically adds selected price (with quantity) to the ATC button
 */

window.initATCPriceDisplay = function(containerSelector, sectionId) {
  const waitForElement = (selector, callback) => {
    const interval = setInterval(() => {
      const el = document.querySelector(selector);
      if (el) {
        clearInterval(interval);
        callback(el);
      }
    }, 200);
  };

  waitForElement(containerSelector, () => {
    const container = document.querySelector(containerSelector);
    if (!container) return;

    const getQuantity = () => {
      const quantityInput = document.querySelector('input[name="quantity"]');
      return quantityInput ? parseInt(quantityInput.value) || 1 : 1;
    };

    const parsePrice = (priceText) => {
      if (!priceText) return null;
      // Extract numeric value from price string (e.g., "$39.99" -> 39.99)
      const match = priceText.match(/[\d,\.]+/);
      if (!match) return null;
      return parseFloat(match[0].replace(/,/g, ''));
    };

    const formatPrice = (value, originalPrice) => {
      // Extract currency symbol and format from original price
      const currencyMatch = originalPrice.match(/^([^\d\s]+)/);
      const currency = currencyMatch ? currencyMatch[1] : '$';
      
      // Format with 2 decimal places
      const formatted = value.toFixed(2);
      return currency + formatted;
    };

    const getSelectedPrice = () => {
      const selected = container.querySelector('.plan-option input[type="radio"]:checked');
      if (!selected) return null;

      const option = selected.closest(".plan-option");
      const priceEl = option?.querySelector(".plan-price-current");
      if (!priceEl) return null;

      const priceText = priceEl.textContent.trim();
      const unitPrice = parsePrice(priceText);
      
      if (!unitPrice) return priceText;

      const quantity = getQuantity();
      if (quantity <= 1) return priceText;

      const totalPrice = unitPrice * quantity;
      return formatPrice(totalPrice, priceText);
    };

    const ensureATCPrice = (price) => {
      if (!price) return;

      // Target the MAIN button specifically using section ID if provided
      let submitBtn;
      if (sectionId) {
        submitBtn = document.querySelector("#ProductSubmitButton-" + sectionId);
      } else {
        submitBtn = document.querySelector(".product-form__submit:not(.product-sticky-atc-bar__submit)");
      }
      
      if (!submitBtn) return;

      let priceSpan = submitBtn.querySelector(".atc-price-display");

      if (!priceSpan) {
        // Insert price after the main text span (not inside it)
        // Find the text span (first direct child span, not loading spinner)
        const textSpan = Array.from(submitBtn.children).find(el => 
          el.tagName === 'SPAN' && !el.classList.contains('loading__spinner')
        );
        
        priceSpan = document.createElement("span");
        priceSpan.className = "atc-price-display";
        
        // Create a wrapper to hold both separator and price
        const priceWrapper = document.createDocumentFragment();
        priceWrapper.appendChild(document.createTextNode(" · "));
        priceWrapper.appendChild(priceSpan);
        
        // Insert after the text span
        if (textSpan) {
          textSpan.after(priceWrapper);
        } else {
          // Fallback if structure is different - append to button
          submitBtn.appendChild(priceWrapper);
        }
      }

      priceSpan.textContent = price;
    };

    const update = () => {
      ensureATCPrice(getSelectedPrice());
    };

    // Listen to variant radio changes
    const radios = container.querySelectorAll('.plan-option input[type="radio"]');
    radios.forEach((radio) => {
      radio.addEventListener("change", update);
    });

    // Listen to quantity changes
    const quantityInput = document.querySelector('input[name="quantity"]');
    if (quantityInput) {
      quantityInput.addEventListener("change", update);
      quantityInput.addEventListener("input", update);
    }

    // Watch for button state changes (loading animations, etc.)
    const observeButton = () => {
      let submitBtn;
      if (sectionId) {
        submitBtn = document.querySelector("#ProductSubmitButton-" + sectionId);
      } else {
        submitBtn = document.querySelector(".product-form__submit:not(.product-sticky-atc-bar__submit)");
      }

      if (submitBtn) {
        // Use MutationObserver to detect when loading class is removed
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
              const hasLoading = submitBtn.classList.contains('loading');
              // Re-apply price when loading is removed (after form submission completes)
              if (!hasLoading) {
                setTimeout(update, 50);
              }
            }
          });
        });

        observer.observe(submitBtn, {
          attributes: true,
          attributeFilter: ['class']
        });
      }
    };

    observeButton();
    update();
  });
};


